import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import ModalAddDevice from "screens/ModalAddDevice";
import { useQuery } from "@apollo/client";
import { GET_ALL_DEVICES } from "graphql/service";
import { Content, CouponTableContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import { RemoveIcon, EditIcon } from "assets/icons";

const Devices = () => {

  const [devices, setDevices] = useState([]);

  const { data: devicesData, error } = useQuery(GET_ALL_DEVICES);

  useEffect(() => {
    if (devicesData) {
      setDevices(devicesData.devices);
    }
  }, [devicesData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  const deviceArray = devices.map((device, index) => {
    return (
      <tr key={index}>
        <td className="deviceName">{device.name}</td>
        <td className="deviceType">{device.type}</td>
        <td className="port">{device.port}</td>
        <td className="ipAddress">{device.ipAddress}</td>
        <td className="action">
          <span className="edit">
            <EditIcon /> Edit
          </span>
          <span className="delete">
            <RemoveIcon /> Remove
          </span>
        </td>
      </tr>
    );
  });

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="cardTitle">CURRENT DEVICES</div>
        <div className="buttonContainer">
          <ModalAddDevice
            buttonStyle={`
              width: 134px;
            `}
            setDevices={setDevices}
          />
        </div>
      </CardHeader>
      <Content>
        {deviceArray.length === 0 ? (
          <div className="noDevice">
            There are no devices available. Please use 'Add New Device' to create one.
          </div>
        ) : (
          <>
            <div className="deviceDescription">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. culpa qui officia
              deserunt mollierunt mollie.”
            </div>
            <CouponTableContainer>
              <thead>
                <tr>
                  <th className="deviceName">NAME</th>
                  <th className="deviceType">DEVICE TYPE</th>
                  <th className="port">PORT</th>
                  <th className="ipAddress">IP ADDRESS</th>
                  <th className="action">ACTION</th>
                </tr>
              </thead>
              <tbody>{deviceArray}</tbody>
            </CouponTableContainer>
          </>
        )}
      </Content>
    </Card>
  );
};

export default Devices;
